import { render } from "./4.vue?vue&type=template&id=aa9fced8&scoped=true"
import script from "./4.vue?vue&type=script&lang=js"
export * from "./4.vue?vue&type=script&lang=js"

import "./4.vue?vue&type=style&index=0&id=aa9fced8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9fced8"]])

export default __exports__